/* eslint-disable vue/multi-word-component-names */

<template>
  <main class="product">
    <div class="product__img-container">
      <img :src="product.productImgUrl1" :alt="product.productImgAlt1" class="product__img" v-if="product.productImgUrl1"/>
      <img :src="product.productImgUrl2" :alt="product.productImgAlt2" class="product__img" v-if="product.productImgUrl2"/>
      <img :src="product.productImgUrl3" :alt="product.productImgAlt3" class="product__img" v-if="product.productImgUrl3"/>
      <img :src="product.productImgUrl4" :alt="product.productImgAlt4" class="product__img" v-if="product.productImgUrl4"/>
      <img :src="product.productImgUrl5" :alt="product.productImgAlt5" class="product__img" v-if="product.productImgUrl5"/>
      <img :src="product.productImgUrl6" :alt="product.productImgAlt6" class="product__img" v-if="product.productImgUrl6"/>
      <img :src="product.productImgUrl7" :alt="product.productImgAlt7" class="product__img" v-if="product.productImgUrl7"/>
    </div>

    <div class="product__copy-container">
      <h1 class="product__heading">project</h1>
      <p class="product__copy">{{ product.productTitle }}</p>
      <h2 class="product__heading">client</h2>
      <p class="product__copy">{{ product.client }}</p>
      <h2 class="product__heading">description</h2>
      <p class="product__copy" v-html="product.productDescription"></p>
      <!-- <h2 class="product__heading">date completed</h2> -->
      <!-- <p class="product__copy">{{ product.dateCompleted }}</p> -->
      <h2 class="product__heading" v-if="product.clientSite">view site</h2>
      <a :href="product.clientSite" target="_blank" class="product__site-link">{{ product.clientSite }}</a>
    </div>
    <div class="speech-bubble  speech-bubble--testimonial  speech-bubble--margin" v-if="product.testimonial">
      <img src="../assets/site-icons/quote-icon.svg" alt="white icon of speech marks to signify a testimonial or quote from customer" class="speech-bubble__icon"/>
      <section class="speech-bubble__copy-container">
        <h2 class="speech-bubble__heading">{{ product.client }}</h2>
        <p class="speech-bubble__copy" v-html="product.testimonial"></p>
      </section>
    </div>
  </main>
</template>

<script type="text/javascript">
export default {
  data() {
    return {
      id: this.$route.params.id,
      product: {}
    };
  },
  created() {
    const vm = this;
    this.axios
      .get("/db.json")
      .then(data => {
        vm.product = data.data.find(
        filteredProduct => filteredProduct.id == this.id
      );
      document.title = `mjccreative | ${vm.product.productTitle}`;
    });
  }
};
</script>

<style lang="scss" scoped>
@use "../assets/scss/_siteVariables";

.product {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
  &__img-container {
    padding-right: 15px;
    padding-left: 15px;
    display: block;
    position: relative;
    flex: 0 0 100%;
    max-width: 100%;
    width: 100%;
    @media only screen and (min-width: 900px) {
      flex: 0 0 66.66667%;
      max-width: 66.66667%;
    }
  }
  &__copy-container {
    padding-right: 15px;
    padding-left: 15px;
    display: block;
    position: relative;
    flex: 0 0 100%;
    max-width: 100%;
    width: 100%;
    @media only screen and (min-width: 900px) {
      flex: 0 0 33.33333%;
      max-width: 33.33333%;
      padding-right: 13%;
    }
  }
  &__img {
    margin: 0 auto 30px;
    display: block;
    max-width: 100%;
    width: 100%;
    border-radius: 10px;
  }
  &__heading {
    font-size: 18px;
    margin-top: 0;
    color: var(--darkest-grey);
  }
  &__copy {
    font-size: 14px;
    letter-spacing: 0;
    line-height: 1.5;
    color: var(--darkest-grey);
  }
  &__site-link {
    color: var(--accent);
    text-decoration: none;
    display: inline-block;
    &::after {
      content: "";
      display: block;
      width: 0px;
      height: 1px;
      bottom: 0;
      background-color: var(--accent);
      transition: all 0.25s cubic-bezier(0.645, 0.045, 0.355, 1) 0s;
    }
    &:hover::after {
      width: 100%;
    }
  }
}
</style>
